import { TeamChip } from '@/features/courts/components/kit/team-chip';
import type { Match } from '@/types/api';
import type { SetsConfig, SetsState } from '@/types/sports/sets';
import type { SportMatch } from '@/types/sports/wire';

export const SetsPreview = ({ match }: { match: Match }) => {
  const {
    away_team,
    home_team,
    state: { current_set, scores },
  } = match as SportMatch<SetsConfig, SetsState>;

  return (
    <div>
      <div className="flex items-center justify-between space-x-2 text-6xl">
        <div>{scores.home_team}</div>
        <div>{scores.away_team}</div>
      </div>

      <div className="flex items-center justify-between space-x-2 text-xl text-gray-500">
        <div>{current_set.home_team}</div>
        <div>{current_set.away_team}</div>
      </div>

      <div className="mt-4 flex items-center justify-between space-x-2">
        <TeamChip team={home_team} />
        <div>vs</div>
        <TeamChip team={away_team} reverse />
      </div>
    </div>
  );
};
